import { render } from "./AntepostEvent.vue?vue&type=template&id=e043d4a6&scoped=true"
import script from "./AntepostEvent.vue?vue&type=script&lang=js"
export * from "./AntepostEvent.vue?vue&type=script&lang=js"

import "./AntepostEvent.vue?vue&type=style&index=0&id=e043d4a6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e043d4a6"]])

export default __exports__